module.exports = __webpack_public_path__ + "static/NOI3-4c817d272bd74203c95ad7aff8cd04d9.jpg";